import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ExpandMojoAudio = props => (
  <SvgIcon
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentcolor"
      d={
        `M16.8751 0C17.4964 0 18 0.50362 18 1.12487L18 6.7492C18 7.37045 17.4964 7.87407 16.8751 7.87407C16.2539 7.87407 15.7503 7.37045 15.7503 6.7492V3.84704L12.0495 7.54786L12.0429 7.55438C11.6018 7.99186 10.8896 7.98894 10.4521 7.54786L10.4456 7.54133C10.0081 7.10025 10.0111 6.38803 10.4521 5.95055L14.1417 2.24973H11.2508C10.6296 2.24973 10.1259 1.74611 10.1259 1.12487C10.1259 0.50362 10.6296 0 11.2508 0H16.8751ZM5.95707 10.4434C6.39815 10.0059 7.11037 10.0089 7.54786 10.4499L7.55438 10.4565C7.99186 10.8976 7.98894 11.6098 7.54786 12.0473L3.84704 15.7481H6.7492C7.37045 15.7481 7.87407 16.2517 7.87407 16.8729C7.87407 17.4942 7.37045 17.9978 6.7492 17.9978H1.12487C0.50362 17.9978 0 17.4942 0 16.8729V11.2486C0 10.6274 0.50362 10.1237 1.12487 10.1237C1.74611 10.1237 2.24973 10.6274 2.24973 11.2486V14.1395L5.95055 10.4499L5.95707 10.4434Z`
      }
    />
  </SvgIcon>
);

export default ExpandMojoAudio;
